(function() {
  const params = new URLSearchParams(window.location.search);
  const coupon = params.get('cp');

  if (coupon) {
    fetch('/discount/' + encodeURIComponent(coupon))
      .catch(error => {
        console.error('Coupon application failed:', error);
      });
  }
})();

(function() {
  function initLineBannerClose() {
    const banner = document.getElementById('js-line-fixed-banner');
    if (!banner) return;

    const closeBtn = banner.querySelector('.close-btn');
    if (closeBtn) {
      closeBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        banner.classList.add('is-hidden');
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLineBannerClose);
  } else {
    initLineBannerClose();
  }
})();

/**
 * 汎用スライダー初期化 (Swiper.js)
 */
const initCustomSliders = () => {
  const sliderElements = document.querySelectorAll('.snap-photo-slider');

  sliderElements.forEach((el) => {
    if (el.classList.contains('swiper-initialized')) return;

    new Swiper(el, {
      loop: true,
      centeredSlides: true,
      grabCursor: true,
      observer: true,
      observeParents: true,
      watchSlidesProgress: true,
      
      slidesPerView: 1.4,
      spaceBetween: 16,
      
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      
      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 4.5,
          spaceBetween: 30,
        }
      }
    });
  });
};

document.addEventListener('DOMContentLoaded', initCustomSliders);



document.addEventListener('DOMContentLoaded', () => {
  const openBtn = document.getElementById('openBtn');
  const body = document.body;

  if (openBtn) {
    openBtn.addEventListener('click', (e) => {
      e.preventDefault();

      let modalMask = document.getElementById('modalMask');
      if (!modalMask) {
        const modalHTML = `
          <div id="modalMask" class="hidden">
            <div id="modalContent">
              <div class="photo-grid">
                ${Array.from({ length: 17 }, (_, i) => {
                  const num = (i + 1).toString().padStart(2, '0');
                  return `<div class="grid-item"><img src="https://cdn.shopify.com/s/files/1/0655/5713/5583/files/2026ss_img${num}.jpg?v=1769401422" alt="Product"></div>`;
                }).join('')}
              </div>
              <div style="text-align:center; padding: 40px 0;">
                <button id="closeModalBtn" style="padding:12px 40px; background:#333; color:#fff; border-radius:30px; cursor:pointer;">閉じる</button>
              </div>
            </div>
          </div>
        `;
        body.insertAdjacentHTML('beforeend', modalHTML);
        modalMask = document.getElementById('modalMask');

        modalMask.addEventListener('click', (event) => {
          if (event.target === modalMask) closeModal();
        });
        
        document.getElementById('closeModalBtn').addEventListener('click', closeModal);
      }

      modalMask.classList.remove('hidden');
      body.classList.add('no-scroll');
      
      document.querySelector('.section-header')?.classList.add('spOnly');
      document.querySelector('.line-fixed-button')?.classList.add('spOnly');

      const modalContent = document.getElementById('modalContent');
      if (modalContent) modalContent.scrollTop = 0;
    });
  }

  function closeModal() {
    const modalMask = document.getElementById('modalMask');
    if (modalMask) {
      modalMask.classList.add('hidden');
      body.classList.remove('no-scroll');
      document.querySelector('.section-header')?.classList.remove('spOnly');
      document.querySelector('.line-fixed-button')?.classList.remove('spOnly');
    }
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const TARGET_TEXT = "一覧を見る";

  document.querySelectorAll(".blog-article a, article a, .rte a").forEach(function (a) {
    if (a.textContent.trim().includes(TARGET_TEXT)) {
      a.classList.add("tagL");
    }
  });
});


// add: アイテム一覧ドロワー
document.addEventListener('DOMContentLoaded', function() {
  const popup = document.getElementById('summer2026popup');
  if (!popup) return;

  const openBtn = popup.querySelector('#open-item-list');
  const drawer = document.getElementById('item-list-drawer');
  const closeBtn = document.getElementById('close-item-list');
  const inner = document.getElementById('item-list-inner');

  if (!openBtn || !drawer || !closeBtn || !inner) return;

  let cardSwipersInitialized = false;

  // カラーアイコンのアクティブ状態を更新
  function updateColorLabel(colorLabel, index) {
    if (!colorLabel) return;
    const icons = colorLabel.querySelectorAll('svg');
    icons.forEach(function(svg, i) {
      svg.style.opacity = (i === index) ? '1' : '0.3';
      svg.style.transform = (i === index) ? 'scale(1.3)' : 'scale(1)';
    });
  }

  // 共通: 任意のコンテナ内の .card-swiper を初期化
  function initSwiperCards(container) {
    container.querySelectorAll('.card-swiper').forEach(function(el) {
      if (el.swiper) return; // 初期化済みはスキップ
      const colorLabel = el.closest('.card').querySelector('.color-label');
      const slideCount = el.querySelectorAll('.swiper-slide').length;

      // 初期状態：先頭をアクティブに
      updateColorLabel(colorLabel, 0);

      new Swiper(el, {
        loop: slideCount > 1,
        navigation: {
          nextEl: el.querySelector('.swiper-button-next'),
          prevEl: el.querySelector('.swiper-button-prev'),
        },
        on: {
          slideChange: function() {
            updateColorLabel(colorLabel, this.realIndex);
          }
        }
      });

      if (slideCount <= 1) {
        const prevBtn = el.querySelector('.swiper-button-prev');
        const nextBtn = el.querySelector('.swiper-button-next');
        if (prevBtn) prevBtn.style.display = 'none';
        if (nextBtn) nextBtn.style.display = 'none';
      }
    });
  }

  // sec04（ALL ITEM）: ページ読み込み時に初期化
  const sec04 = popup.querySelector('.sec04');
  if (sec04) {
    initSwiperCards(sec04);
  }

  // ドロワー内カード: 初回オープン時に初期化
  function initCardSwipers() {
    if (cardSwipersInitialized) return;
    cardSwipersInitialized = true;
    initSwiperCards(drawer);
  }

  // ドロワーを開く
  openBtn.addEventListener('click', function(e) {
    e.preventDefault();
    inner.scrollTop = 0;
    drawer.showModal();
    requestAnimationFrame(function() {
      inner.classList.add('is-open');
      initCardSwipers();

      // 毎回スライドを先頭に戻す
      drawer.querySelectorAll('.card-swiper').forEach(function(el) {
        if (el.swiper) {
          const swiper = el.swiper;
          if (swiper.params.loop) {
            swiper.slideToLoop(0, 0);
          } else {
            swiper.slideTo(0, 0);
          }
          // カラーアイコンも先頭に戻す
          const colorLabel = el.closest('.card').querySelector('.color-label');
          updateColorLabel(colorLabel, 0);
        }
      });
    });
    document.body.style.overflow = 'hidden';
  });

  // ドロワーを閉じる
  closeBtn.addEventListener('click', function() {
    inner.classList.remove('is-open');
    setTimeout(function() {
      drawer.close();
      document.body.style.overflow = '';
    }, 400);
  });
});

// フェードインアニメーション
document.addEventListener('DOMContentLoaded', function() {
  const popup = document.getElementById('summer2026popup');
  if (!popup) return;

  // アニメーション対象を取得してクラス付与
  const targets = popup.querySelectorAll(
    'p, img, a, .card, .limited-box, .note, .secTtl, .item-info, .payment-sec, .divider'
  );

  targets.forEach(function(el, i) {
    el.classList.add('fade-up');
    // 連続する要素に少しずつ遅延をつける（最大0.4s）
    el.style.transitionDelay = Math.min(i % 6 * 0.08, 0.4) + 's';
  });

  // IntersectionObserver でビューポートに入ったら表示
  const observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target); // 一度表示したら監視解除
      }
    });
  }, {
    threshold: 0.1,
    rootMargin: '0px 0px -40px 0px' // 少し手前で発火
  });

  targets.forEach(function(el) {
    observer.observe(el);
  });
});